<template>
  <div class="orientation-tip" v-if="!isLandscape">
    <div class="orientation-tip-content">
      <div class="orientation-tip-icon"></div>
      <div class="orientation-tip-text">請將設備橫置以獲得最佳體驗</div>
      <div class="orientation-tip-subtext">Please rotate your device to landscape mode</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const isLandscape = ref(true);

const checkOrientation = () => {
  // 横屏：宽度 > 高度
  isLandscape.value = window.innerWidth > window.innerHeight;
};

onMounted(() => {
  checkOrientation();
  window.addEventListener('resize', checkOrientation);
  window.addEventListener('orientationchange', checkOrientation);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkOrientation);
  window.removeEventListener('orientationchange', checkOrientation);
});
</script>

<style scoped lang="less">
.orientation-tip {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.orientation-tip-content {
  text-align: center;
  color: white;
  padding: 40px;
}

.orientation-tip-icon {
  width: 100px;
  height: 100px;
  margin: 0 auto 30px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z'/%3E%3C/svg%3E") center/contain no-repeat;
  animation: rotate 2s ease-in-out infinite;
}

@keyframes rotate {
  0%, 100% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(90deg);
  }
}

.orientation-tip-text {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.orientation-tip-subtext {
  font-size: 16px;
  opacity: 0.7;
}

/* 横屏时隐藏提示 */
@media (orientation: landscape) {
  .orientation-tip {
    display: none;
  }
}
</style>
